module.exports = __webpack_public_path__ + "img/05597965000208.fbbd95a5.png";